import { EnumObject } from './enum-object';

export const BaseOnlineMatchStatus = {
  TransferToCemAndKam: 'process',
  DontSend: 'dont_send',
  WaitForCv: 'wait_for_cv',
  FollowUp: 'follow_up',
  TooManyMatches: 'too_many_matches',
  NoData: 'no_data',
  KamRequest: 'kam_request',
  Doublecheck: 'doublecheck',
  RejectedByCandidate: 'rejected_by_candidate',
  Unsolicited: 'unsolicited_send',
  InQueue: 'in_queue',
  CompromiseProcess: 'compromise_process',
} as const;

export type BaseOnlineMatchStatus = EnumObject<typeof BaseOnlineMatchStatus>;

export const BASE_ONLINE_MATCH_STATUS_I18N: Record<BaseOnlineMatchStatus, string> = {
  [BaseOnlineMatchStatus.TransferToCemAndKam]: 'Senden',
  [BaseOnlineMatchStatus.FollowUp]: 'WVL',
  [BaseOnlineMatchStatus.WaitForCv]: 'Warten auf CV',
  [BaseOnlineMatchStatus.TooManyMatches]: 'Zu viele Matches',
  [BaseOnlineMatchStatus.DontSend]: 'Nicht senden',
  [BaseOnlineMatchStatus.NoData]: 'Keine Daten',
  [BaseOnlineMatchStatus.KamRequest]: 'Anfrage KAM',
  [BaseOnlineMatchStatus.Doublecheck]: 'Doublecheck',
  [BaseOnlineMatchStatus.Unsolicited]: 'Initiativ Senden',
  [BaseOnlineMatchStatus.RejectedByCandidate]: 'Vom Kandidaten abgelehnt',
  [BaseOnlineMatchStatus.InQueue]: 'Warten auf Auto-Verarbeitung',
  [BaseOnlineMatchStatus.CompromiseProcess]: 'Kompromissprozess',
};
